import React, { useState, useEffect } from 'react';
import useDrawerContent from './useDrawerContent';
import { Switch, Route, NavLink } from "react-router-dom";
import '../NavBar/NavBar.css';
import axios from 'axios'
import { APIURL, } from '../../config'
import SideBar from '../MenuSideBar/SideBar';
import Projects from '../Projects/Updated_Projects'
import Customers from '../Customers_V2/Customers'
import Households from '../Households/Households'
import Residences from '../Residences/Residences'
import Billing from '../../components/Billing/Billing'
import EmpLocate from '../../components/EmpLocate/EmpLocate'
import EmployeePage from '../Employee/EmployeePage'
import Contacts from '../../components/Contacts/Contactsv1'
import SupportCoordinationEmployeeHome from '../Employee/EmployeeHome/SupportCoordinationEmployeeHome'
import ServiceProviderEmployeeHome from '../Employee/EmployeeHome/ServiceProviderEmployeeHome'
import HomeHealthcareEmployeeHome from '../Employee/EmployeeHome/HomeHealthcareEmployeeHome'
import CaseManagementEmployeeHome from '../Employee/EmployeeHome/CaseManagementEmployeeHome'
import EmployeeHome from '../Employee/EmployeeHome/EmployeeHome'
import TeamWorkload from '../../components/TeamWorkload/TeamWorkload'
import Reports_V2 from '../../components/Reports_V2/Reports';
import Settings from '../../components/Settings/NewSettings'
import TimeSummaryAlt2 from '../../container/TimeManagement/TimeSummaryAlt2'
import Scheduler from '../../container/Scheduler/Scheduler'
import EvvV1 from '../../components/Evv/EvvV1'
import EVV_AZ from '../../components/EVV_AZ/EVV_Arizona'
import Notifications from "../../components/Notifications/notifications";
import FormBuilder from '../../container/Forms/FormBuilder';
import Invoice from "../../components/Evv/Invoices/Invoices";
import DebugContainer from "../Debug/DebugContainer"
import SubscriptionModal from "../Landing/SubscriptionModal";
import BasicCompanySettingsModal from "../Landing/BasicCompanySettingsModal";
import SupportCoordinatorHome from '../../container/SupportCoordinator/SupportCoordinatorHome'
import SupportCoordinatorSupervisorHome from '../../container/Manager/SupportCoordinatorSupervisorHome';
import DayCareEmployeeHome from '../Employee/EmployeeHome/DayCareEmployeeHome';
import MessageBanner from '../../components/MessageBanner/MessageBanner';
import Documents from '../Documents/Documents'
import Forms from '../Forms/Forms';
import Workflows from '../Workflows/Workflows';
import Referral from '../Referral/Referral';
import { People, Home, IntegrationInstructions, Person, Room, AddCircle, AccessTimeFilled, Map, InsertDriveFile, Receipt, FormatListBulleted, CalendarToday, PersonAdd, FamilyRestroom, AutoAwesome, Badge } from '@mui/icons-material';
import AiCompanion from '../../components/AiCompanion/AiCompanion';
import MuiDrawer from '@mui/material/Drawer';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import Box from '@mui/material/Box';
import ButtonBase from '@mui/material/ButtonBase';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemButton from '@mui/material/ListItemButton';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import KeyboardDoubleArrowLeft from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRight from '@mui/icons-material/KeyboardDoubleArrowRight';
import AccountTreeOutlinedIcon from '@mui/icons-material/AccountTreeOutlined';
import PaidOutlined from "@mui/icons-material/PaidOutlined";
import { useLocation } from 'react-router-dom/cjs/react-router-dom';

const drawerWidth = 190;
const dollarBadgeSx = {
    color: '#3FA7D6',
    bgcolor: '#f3f9fc',
    borderRadius: '50%',
    flexShrink: 0,
    ml: 0.5,
    fontSize: 16
};
const sidebarPaperStyles = {
    backgroundColor: '#f3f9fc',
    borderRight: '1px solid #d8e8f0',
    boxShadow: '4px 0 16px rgba(31, 45, 61, 0.08)',
    display: 'flex',
    flexDirection: 'column',
    overflowY: 'hidden',
    '@media (prefers-reduced-motion: reduce)': { transition: 'none' }
};

const openedMixin = (theme) => ({
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
    overflowX: 'hidden',
    ...sidebarPaperStyles,
  });
  
const closedMixin = (theme) => ({
transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
}),
overflowX: 'hidden',
width: `calc(${theme.spacing(8)} + 1px)`,
...sidebarPaperStyles,
[theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(9)} + 1px)`,
},
});

const NAV_GROUPS_STORAGE_KEY = 'fw.sidebar.openNavGroups';

const Drawer = styled(MuiDrawer, { shouldForwardProp: (prop) => prop !== 'open' })(
({ theme, open }) => ({
    width: drawerWidth,
    flexShrink: 0,
    whiteSpace: 'nowrap',
    boxSizing: 'border-box',
    zIndex: 100,
    ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': openedMixin(theme),
    }),
    ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': closedMixin(theme),
    }),
}),
);

export default function GeneralSidebar(props) {
    const [screen, setScreen] = useState('home');
    const [toModule, setToModule] = useState('task');
    const [companySettings, setCompanySettings] = useState([]);
    const [open, setOpen] = useState(true);
    const { contentExpanded, onTransitionEnd } = useDrawerContent(open);
    const [payerList, setPayerList] = useState([]);
    const [activatedFeatures, setActivatedFeatures] = useState(props.activatedFeatures);
    let location = useLocation();
    // Which nav groups the user closed or opened, remembered in this browser. Groups start open.
    const [openNavGroups, setOpenNavGroups] = useState(() => {
        try {
            return JSON.parse(window.localStorage.getItem(NAV_GROUPS_STORAGE_KEY)) || {};
        } catch {
            return {};
        }
    });
    const navigationListSx = {
        p: 0.75,
        mt: 8.5,
        flex: '1 1 auto',
        overflowY: 'auto',
        overflowX: 'hidden',
        scrollbarWidth: 'thin',
        scrollbarColor: 'rgba(63, 167, 214, 0.55) transparent',
        backgroundColor: '#f3f9fc',
        '&::-webkit-scrollbar': {
            width: 6
        },
        '&::-webkit-scrollbar-track': {
            backgroundColor: 'transparent'
        },
        '&::-webkit-scrollbar-thumb': {
            backgroundColor: 'rgba(63, 167, 214, 0.45)',
            borderRadius: 8,
            border: '1px solid transparent',
            backgroundClip: 'padding-box'
        },
        '&::-webkit-scrollbar-thumb:hover': {
            backgroundColor: '#3FA7D6'
        },
        '& > .MuiListItem-root': {
            width: 'calc(100% - 8px)',
            mx: 0.5,
            mb: 0.25,
            borderRadius: '10px',
            borderRight: 'none !important',
            backgroundColor: 'transparent',
            overflow: 'hidden',
            transition: 'transform 150ms ease, box-shadow 150ms ease',
            '&:hover': {
                transform: 'translateX(2px)',
                backgroundColor: '#e5f4fb',
                boxShadow: '0 4px 12px rgba(31, 45, 61, 0.10)'
            }
        },
        '& > .MuiListItem-root:has(> .active)': {
            backgroundColor: '#d6eef9',
            boxShadow: 'inset 3px 0 0 #3FA7D6'
        },
        '& > .MuiListItem-root:has(> .active) .MuiListItemText-root': {
            color: '#3FA7D6 !important'
        },
        '& > .MuiListItem-root:has(> .active) .MuiListItemIcon-root svg': {
            color: '#3FA7D6 !important'
        },
        '& > .MuiListItem-root:has(> .active) .sidebar-dollar-badge': {
            backgroundColor: '#d6eef9'
        },
        '& > .MuiListItem-root > a': {
            display: 'block',
            width: '100%'
        },
        '& .MuiListItemButton-root': {
            width: '100% !important',
            minHeight: '40px !important',
            paddingLeft: contentExpanded ? '8px !important' : '0 !important',
            paddingRight: contentExpanded ? '8px !important' : '0 !important',
            justifyContent: contentExpanded ? 'flex-start !important' : 'center !important',
            transition: 'background-color 150ms ease'
        },
        '& .MuiListItemIcon-root': {
            minWidth: '0 !important',
            marginLeft: contentExpanded ? '0 !important' : 'auto !important',
            marginRight: contentExpanded ? '8px !important' : 'auto !important',
            justifyContent: 'center !important'
        },
        '& .MuiListItemText-root': {
            // Preserve the label's height and vertical margins in compact mode.
            display: 'block',
            ...(!contentExpanded && {
                visibility: 'hidden',
                flex: '0 0 0px',
                width: 0,
                overflow: 'hidden'
            })
        },
        '& .MuiListItemIcon-root svg:not(.sidebar-dollar-badge)': {
            fontSize: 21
        },
        '& .MuiListItemText-primary': {
            fontSize: 16,
            fontWeight: 600,
            letterSpacing: '0.01em',
            lineHeight: 1.2,
            whiteSpace: 'nowrap'
        }
    };

    useEffect(() => {
        const getCompanySettings = async() => {
            let response = (await axios.get(APIURL + '/config/settings', { params: { comp_id: props.user.comp_id } })).data
            setCompanySettings(response)
            let payerDetails = await axios.get(APIURL + `/associate_payer`, {
                params : {
                    compId: props.user.comp_id,
                }
            });
            setPayerList(payerDetails.data);
        }
        getCompanySettings();
    }, []);
    
    
    const changeScreen = (newScreenName, newToModule) => {
        setScreen(newScreenName)
        setToModule(newToModule)
    }

    useEffect(() => {
        if (!["/", "/projects", "/customers", "/households", "/residences", "/contacts", "/employees", "/timesheets", "/documents", "/forms", "/billing", "/referral", "/referrals", "/scheduler", "/workflows", "/locate", "/new", "/evv", "/evvAZ", "/ai-companion"].includes(location.pathname)) {
            setScreen("");
        } else {
            // Set the screen state based on the current path
            if (location.pathname === "/locate") {
                setScreen("locate");
            } else if (location.pathname === "/new") {
                setScreen("new");
            } else if (location.pathname === "/evv") {
                setScreen("evv");
            } else if (location.pathname === "/evvAZ") {
                setScreen("evvAZ");
            } else if (location.pathname === "/projects") {
                setScreen("projects");
            } else if (location.pathname === "/customers") {
                setScreen("customers");
            } else if (location.pathname === "/households") {
                setScreen("households");
            } else if (location.pathname === "/residences") {
                setScreen("residences");
            } else if (location.pathname === "/contacts") {
                setScreen("contacts");
            } else if (location.pathname === "/employees") {
                setScreen("employees");
            } else if (location.pathname === "/timesheets") {
                setScreen("timesheets");
            } else if (location.pathname === "/documents") {
                setScreen("documents");
            } else if (location.pathname === "/forms") {
                setScreen("forms");
            } else if (location.pathname === "/billing") {
                setScreen("billing");
            } else if (location.pathname === "/referral" || location.pathname === "/referrals") {
                setScreen("referral");
            } else if (location.pathname === "/scheduler") {
                setScreen("scheduler");
            } else if (location.pathname === "/workflows") {
                setScreen("workflow");
            } else if (location.pathname === "/ai-companion") {
                setScreen("ai-companion");
            } else if (location.pathname === "/" || location.pathname === "/home") {
                setScreen("home");
            }
        }
    }, [location])

    const showButtonHome = () => {
        return (
            <Tooltip title={contentExpanded ? '' : 'Home'} placement="right" arrow>
            <ListItem
                key={'home'}
                disablePadding
                sx={{
                    backgroundColor: screen === 'home' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                    borderRight: '1px solid #3FA7D6'
                }}
            >
                <NavLink onClick={() => { setScreen('home') }} to="/" exact style={{ textDecoration: 'none' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: contentExpanded ? 'initial' : 'center',
                            px: 2.5,
                            width: drawerWidth
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: contentExpanded ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <Home style={{ color: screen === 'home' ? 'white' : '#3FA7D6' }} fontSize="large" />
                        </ListItemIcon>
                        <ListItemText
                            primary="Home"
                            sx={{
                                opacity: contentExpanded ? 1 : 0,
                                color: screen === 'home' ? 'white' : '#3FA7D6'
                            }}
                        />
                    </ListItemButton>
                </NavLink>
            </ListItem>
            </Tooltip>
        );
    }
    
    const showButtonProjects = () => {
        const label = companySettings.length > 1 && companySettings.some(setting => setting.feature_id == 105) ? 'SDR' : 'Projects';
        return (
            <Tooltip title={contentExpanded ? '' : label} placement="right" arrow>
            <ListItem
                key={'projects'}
                disablePadding
                sx={{
                    backgroundColor: screen === 'projects' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                    borderRight: '1px solid #3FA7D6'
                }}
            >
                <NavLink onClick={() => { setScreen('projects') }} to="/projects" exact style={{ textDecoration: 'none' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: contentExpanded ? 'initial' : 'center',
                            px: 2.5,
                            width: drawerWidth
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: contentExpanded ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <IntegrationInstructions style={{ color: screen === 'projects' ? 'white' : '#3FA7D6' }} fontSize="large" />
                        </ListItemIcon>
                        <ListItemText
                            primary={label}
                            sx={{
                                opacity: contentExpanded ? 1 : 0,
                                color: screen === 'projects' ? 'white' : '#3FA7D6'
                            }}
                        />
                    </ListItemButton>
                </NavLink>
            </ListItem>
            </Tooltip>
        );
    }
    
    const showButtonCustomers = () => {
        let text = companySettings.length > 1 && companySettings.filter(setting => [101, 102, 104].includes(setting.feature_id)).length > 0 ? 'Clients'
            : companySettings.length > 1 && companySettings.filter(setting => setting.feature_id == 105).length > 0 ? 'Members' : 'Customers'
        
        return (
            <Tooltip title={contentExpanded ? '' : text} placement="right" arrow>
            <ListItem
                key={text}
                disablePadding
                sx={{
                    backgroundColor: screen === 'customers' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                    borderRight: '1px solid #3FA7D6'
                }}
            >
                <NavLink onClick={() => { setScreen('customers') }} to="/customers" exact style={{ textDecoration: 'none' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: contentExpanded ? 'initial' : 'center',
                            px: 2.5,
                            width: drawerWidth
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: contentExpanded ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <People style={{ color: screen === 'customers' ? 'white' : '#3FA7D6' }} fontSize="large" />
                        </ListItemIcon>
                        <ListItemText
                            primary={text}
                            sx={{
                                opacity: contentExpanded ? 1 : 0,
                                color: screen === 'customers' ? 'white' : '#3FA7D6'
                            }}
                        />
                    </ListItemButton>
                </NavLink>
            </ListItem>
            </Tooltip>
        );
    }
    
    const showButtonHouseholds = () => {
        const isGroupHome = companySettings.some(setting => setting.feature_id === 106 && setting.feature_value === 'primaryBusinessType');
        const hasHouseholds = companySettings.some(setting => setting.feature_id === 103 && setting.feature_value === 'primaryBusinessType');
        if (isGroupHome || hasHouseholds) {
            const screenName = isGroupHome ? 'residences' : 'households';
            const path = isGroupHome ? '/residences' : '/households';
            const label = isGroupHome ? 'Residences' : 'Households';
            return (
                <Tooltip title={contentExpanded ? '' : label} placement="right" arrow>
                <ListItem
                    key={screenName}
                    disablePadding
                    sx={{
                        backgroundColor: screen === screenName ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen(screenName) }} to={path} exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                <FamilyRestroom style={{ color: screen === screenName ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary={label}
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === screenName ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }
    
    const showButtonContacts = () => {
        return (
            <Tooltip title={contentExpanded ? '' : 'Contacts'} placement="right" arrow>
            <ListItem
                key={'contacts'}
                disablePadding
                sx={{
                    backgroundColor: screen === 'contacts' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                    borderRight: '1px solid #3FA7D6'
                }}
            >
                <NavLink onClick={() => { setScreen('contacts') }} to="/contacts" exact style={{ textDecoration: 'none' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: contentExpanded ? 'initial' : 'center',
                            px: 2.5,
                            width: drawerWidth
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: contentExpanded ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <Person style={{ color: screen === 'contacts' ? 'white' : '#3FA7D6' }} fontSize="large" />
                        </ListItemIcon>
                        <ListItemText
                            primary="Contacts"
                            sx={{
                                opacity: contentExpanded ? 1 : 0,
                                color: screen === 'contacts' ? 'white' : '#3FA7D6'
                            }}
                        />
                    </ListItemButton>
                </NavLink>
            </ListItem>
            </Tooltip>
        );
    }

    const showButtonEmployees = () => {
        const isEmployeeAdmin = Boolean(props.user?.permissions?.SettingsEmployeeTab) ||
            [true, 1, '1', 'true'].includes(props.user?.emp_is_admin) ||
            String(props.user?.emp_type ?? props.user?.type).trim().toLowerCase() === 'admin';
        const label = isEmployeeAdmin ? 'Employees' : 'Employee';
        return (
            <Tooltip title={contentExpanded ? '' : label} placement="right" arrow>
            <ListItem
                key={'employees'}
                disablePadding
                sx={{
                    backgroundColor: screen === 'employees' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                    borderRight: '1px solid #3FA7D6'
                }}
            >
                <NavLink onClick={() => { setScreen('employees') }} to="/employees" exact style={{ textDecoration: 'none' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: contentExpanded ? 'initial' : 'center',
                            px: 2.5,
                            width: drawerWidth
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: contentExpanded ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <Badge style={{ color: screen === 'employees' ? 'white' : '#3FA7D6' }} fontSize="large" />
                        </ListItemIcon>
                        <ListItemText
                            primary={label}
                            sx={{
                                opacity: contentExpanded ? 1 : 0,
                                color: screen === 'employees' ? 'white' : '#3FA7D6'
                            }}
                        />
                    </ListItemButton>
                </NavLink>
            </ListItem>
            </Tooltip>
        );
    }
    
    const showButtonLocate = () => {
        if (activatedFeatures.LocateTab) {
            return (
                <Tooltip title={contentExpanded ? '' : 'Locate'} placement="right" arrow>
                <ListItem
                    key={'locate'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'locate' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('locate') }} to="/locate" exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                <Room style={{ color: screen === 'locate' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Locate"
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'locate' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }
    
    const showButtonNew = () => {
        if (activatedFeatures.NewTab) {
            const label = companySettings.length > 1 && companySettings.some(setting => setting.feature_id == 104) ? 'Intake' : 'Create';
            return (
                <Tooltip title={contentExpanded ? '' : label} placement="right" arrow>
                <ListItem
                    key={'new'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'new' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('new') }} to="/new" exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                <AddCircle style={{ color: screen === 'new' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary={label}
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'new' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }
    
    const showButtonTimesheets = () => {
        if (activatedFeatures.TimesheetsTab) {
                return (
                    <Tooltip title={contentExpanded ? '' : 'Timesheets'} placement="right" arrow>
                    <ListItem
                        key={'timesheets'}
                        disablePadding
                        sx={{
                            backgroundColor: screen === 'timesheets' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                            borderRight: '1px solid #3FA7D6'
                        }}
                    >
                        <NavLink onClick={() => { setScreen('timesheets') }} to="/timesheets" exact style={{ textDecoration: 'none' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: contentExpanded ? 'initial' : 'center',
                                    px: 2.5,
                                    width: drawerWidth
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: contentExpanded ? 3 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <AccessTimeFilled style={{ color: screen === 'timesheets' ? 'white' : '#3FA7D6' }} fontSize="large" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="Timesheets"
                                    sx={{
                                        opacity: contentExpanded ? 1 : 0,
                                        color: screen === 'timesheets' ? 'white' : '#3FA7D6'
                                    }}
                                />
                            </ListItemButton>
                        </NavLink>
                    </ListItem>
                    </Tooltip>
                );
        }
    }
    
    const showButtonEVV = () => {
        if (activatedFeatures.EVVNJ) {
           
                return (
                    <Tooltip title={contentExpanded ? '' : 'EVV'} placement="right" arrow>
                    <ListItem
                        key={'evv'}
                        disablePadding
                        sx={{
                            backgroundColor: screen === 'evv' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                            borderRight: '1px solid #3FA7D6'
                        }}
                    >
                        <NavLink onClick={() => { setScreen('evv') }} to="/evv" exact style={{ textDecoration: 'none' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: contentExpanded ? 'initial' : 'center',
                                    px: 2.5,
                                    width: drawerWidth
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: contentExpanded ? 3 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Map style={{ color: screen === 'evv' ? 'white' : '#3FA7D6' }} fontSize="large" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="EVV"
                                    sx={{
                                        opacity: contentExpanded ? 1 : 0,
                                        color: screen === 'evv' ? 'white' : '#3FA7D6'
                                    }}
                                />
                            </ListItemButton>
                        </NavLink>
                    </ListItem>
                    </Tooltip>
                );

        }
    }
    
    const showButtonEVV_AZ = () => {
        if (activatedFeatures.EVVAZ) {
    
                return (
                    <Tooltip title={contentExpanded ? '' : 'EVV'} placement="right" arrow>
                    <ListItem
                        key={'evvAZ'}
                        disablePadding
                        sx={{
                            backgroundColor: screen === 'evvAZ' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                            borderRight: '1px solid #3FA7D6'
                        }}
                    >
                        <NavLink onClick={() => { setScreen('evvAZ') }} to="/evvAZ" exact style={{ textDecoration: 'none' }}>
                            <ListItemButton
                                sx={{
                                    minHeight: 48,
                                    justifyContent: contentExpanded ? 'initial' : 'center',
                                    px: 2.5,
                                    width: drawerWidth
                                }}
                            >
                                <ListItemIcon
                                    sx={{
                                        minWidth: 0,
                                        mr: contentExpanded ? 3 : 'auto',
                                        justifyContent: 'center',
                                    }}
                                >
                                    <Map style={{ color: screen === 'evvAZ' ? 'white' : '#3FA7D6' }} fontSize="large" />
                                </ListItemIcon>
                                <ListItemText
                                    primary="EVV"
                                    sx={{
                                        opacity: contentExpanded ? 1 : 0,
                                        color: screen === 'evvAZ' ? 'white' : '#3FA7D6'
                                    }}
                                />
                            </ListItemButton>
                        </NavLink>
                    </ListItem>
                    </Tooltip>
                );

        }
    }
    
    const showButtonDocuments = () => {
        if (activatedFeatures.DocumentsTab) {
            return (
                <Tooltip title={contentExpanded ? '' : 'Documents'} placement="right" arrow>
                <ListItem
                    key={'documents'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'documents' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('documents') }} to="/documents" exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                <InsertDriveFile style={{ color: screen === 'documents' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Documents"
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'documents' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }
    
    const showButtonForms = () => {
        return (
            <Tooltip title={contentExpanded ? '' : 'Forms'} placement="right" arrow>
            <ListItem
                key={'forms'}
                disablePadding
                sx={{
                    backgroundColor: screen === 'forms' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                    borderRight: '1px solid #3FA7D6'
                }}
            >
                <NavLink onClick={() => { setScreen('forms') }} to="/forms" exact style={{ textDecoration: 'none' }}>
                    <ListItemButton
                        sx={{
                            minHeight: 48,
                            justifyContent: contentExpanded ? 'initial' : 'center',
                            px: 2.5,
                            width: drawerWidth
                        }}
                    >
                        <ListItemIcon
                            sx={{
                                minWidth: 0,
                                mr: contentExpanded ? 3 : 'auto',
                                justifyContent: 'center',
                            }}
                        >
                            <FormatListBulleted style={{ color: screen === 'forms' ? 'white' : '#3FA7D6' }} fontSize="large" />
                        </ListItemIcon>
                        <ListItemText
                            primary="Forms"
                            sx={{
                                opacity: contentExpanded ? 1 : 0,
                                color: screen === 'forms' ? 'white' : '#3FA7D6'
                            }}
                        />
                    </ListItemButton>
                </NavLink>
            </ListItem>
            </Tooltip>
        );
    }
    
    const showButtonBilling = () => {
        let states = props.user.states
        states = states.map((obj) => obj.state_id)
        let feature = props.user.subs
        feature = feature.map((obj) => obj.feature_id)
        function checkActive() {
            if (String(window.location.href).includes("/billing")) {
                for (var c of document.getElementsByClassName("billing-button-lines")) {
                    c.setAttribute("stroke", "#FFFFFF")
                }
                for (var c of document.getElementsByClassName("billing-button-paths")) {
                    c.setAttribute("fill", "#FFFFFF")
                }
            }
            else {
                for (var c of document.getElementsByClassName("billing-button-lines")) {
                    c.setAttribute("stroke", "#3FA7D6")
                }
                for (var c of document.getElementsByClassName("billing-button-paths")) {
                    c.setAttribute("fill", "#3FA7D6")
                }
            }
            return String(window.location.href).includes("/billing")
        }
        if (activatedFeatures.BillingTab) {
            return (
                <Tooltip title={contentExpanded ? '' : 'Billing'} placement="right" arrow>
                <ListItem
                    key={'billing'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'billing' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('billing') }} to="/billing" exact style={{ textDecoration: 'none' }} isActive={checkActive}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                <Receipt style={{ color: screen === 'billing' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Billing"
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'billing' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }
    
    const showButtonScheduler = () => {
        if (activatedFeatures.SchedulerTab) {
            return (
                <Tooltip title={contentExpanded ? '' : 'Scheduler'} placement="right" arrow>
                <ListItem
                    key={'scheduler'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'scheduler' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('scheduler') }} to="/scheduler" exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                <CalendarToday style={{ color: screen === 'scheduler' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Scheduler"
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'scheduler' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }

    const showButtonWorkflow = () => {
        if (activatedFeatures.WorkflowsTab) {
            return (
                <Tooltip title={contentExpanded ? '' : 'Workflows'} placement="right" arrow>
                <ListItem
                    key={'workflow'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'workflow' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('workflow') }} to="/workflows" exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth,
                                position: 'relative'
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                    position: 'relative'
                                }}
                            >
                                <AccountTreeOutlinedIcon style={{ color: screen === 'workflow' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>Workflows</span>
                                        <PaidOutlined className="sidebar-dollar-badge" sx={dollarBadgeSx} />
                                    </span>
                                }
                                primaryTypographyProps={{ noWrap: true }}
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'workflow' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }

    const showButtonAiCompanion = () => {
        if (activatedFeatures.AICompanionTab) {
            return (
                <Tooltip title={contentExpanded ? '' : 'AI Companion'} placement="right" arrow>
                <ListItem
                    key={'ai-companion'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'ai-companion' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('ai-companion') }} to="/ai-companion" exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth,
                                position: 'relative'
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                    position: 'relative'
                                }}
                            >
                                <AutoAwesome style={{ color: screen === 'ai-companion' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary={
                                    <span style={{ display: 'flex', alignItems: 'center' }}>
                                        <span style={{ overflow: 'hidden', textOverflow: 'ellipsis' }}>AI Companion</span>
                                        <PaidOutlined className="sidebar-dollar-badge" sx={dollarBadgeSx} />
                                    </span>
                                }
                                primaryTypographyProps={{ noWrap: true }}
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'ai-companion' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }

    const showButtonReferral = () => {
        if (activatedFeatures.ReferralsTab) {
            return (
                <Tooltip title={contentExpanded ? '' : 'Referrals'} placement="right" arrow>
                <ListItem
                    key={'referral'}
                    disablePadding
                    sx={{
                        backgroundColor: screen === 'referral' ? '#3FA7D6' : 'rgb(235, 248, 255)',
                        borderRight: '1px solid #3FA7D6'
                    }}
                >
                    <NavLink onClick={() => { setScreen('referral') }} to="/referral" exact style={{ textDecoration: 'none' }}>
                        <ListItemButton
                            sx={{
                                minHeight: 48,
                                justifyContent: contentExpanded ? 'initial' : 'center',
                                px: 2.5,
                                width: drawerWidth
                            }}
                        >
                            <ListItemIcon
                                sx={{
                                    minWidth: 0,
                                    mr: contentExpanded ? 3 : 'auto',
                                    justifyContent: 'center',
                                }}
                            >
                                <PersonAdd style={{ color: screen === 'referral' ? 'white' : '#3FA7D6' }} fontSize="large" />
                            </ListItemIcon>
                            <ListItemText
                                primary="Referrals"
                                sx={{
                                    opacity: contentExpanded ? 1 : 0,
                                    color: screen === 'referral' ? 'white' : '#3FA7D6'
                                }}
                            />
                        </ListItemButton>
                    </NavLink>
                </ListItem>
                </Tooltip>
            );
        }
    }
    
    // The drawer's sections, each item with the paths that count as "in" it. Each
    // showButton* returns nothing when its feature is off for the company, so a group
    // whose items are all hidden is dropped, header too.
    const navGroups = [
        { title: 'CARE', items: [
            ['customers', showButtonCustomers(), ['/customers']],
            ['households', showButtonHouseholds(), ['/households', '/residences']],
            ['contacts', showButtonContacts(), ['/contacts']],
            ['referral', showButtonReferral(), ['/referral', '/referrals']],
        ] },
        { title: 'OPERATIONS', items: [
            ['documents', showButtonDocuments(), ['/documents']],
            ['evv', showButtonEVV(), ['/evv']],
            ['evvAZ', showButtonEVV_AZ(), ['/evvAZ']],
            ['timesheets', showButtonTimesheets(), ['/timesheets']],
        ] },
        { title: 'ADMIN', items: [
            ['employees', showButtonEmployees(), ['/employees']],
            ['locate', showButtonLocate(), ['/locate']],
        ] },
        { title: 'REVENUE', items: [
            ['billing', showButtonBilling(), ['/billing']],
            ['forms', showButtonForms(), ['/forms', '/formbuilder']],
            ['projects', showButtonProjects(), ['/projects']],
        ] },
        { title: 'PLATFORM', items: [
            ['scheduler', showButtonScheduler(), ['/scheduler']],
            ['workflows', showButtonWorkflow(), ['/workflows']],
            ['ai-companion', showButtonAiCompanion(), ['/ai-companion']],
        ] },
    ].map(group => ({ ...group, items: group.items.filter(([, item]) => item) }))
        .filter(group => group.items.length > 0);

    const isNavGroupOpen = (title) => openNavGroups[title] !== false;

    const setNavGroupOpen = (title, isOpen) => {
        setOpenNavGroups(current => {
            if ((current[title] !== false) === isOpen) return current;
            const next = { ...current, [title]: isOpen };
            try {
                window.localStorage.setItem(NAV_GROUPS_STORAGE_KEY, JSON.stringify(next));
            } catch {
                // Storage unavailable (private window, blocked): the state just isn't remembered.
            }
            return next;
        });
    };

    // Opening a page opens its group, so the active item is never hidden behind a
    // collapsed header. Only on navigation: closing that group by hand still works.
    const activeNavGroup = navGroups.find(group =>
        group.items.some(([, , paths]) => paths.includes(location.pathname)))?.title;
    useEffect(() => {
        if (activeNavGroup) setNavGroupOpen(activeNavGroup, true);
    }, [location.pathname, activeNavGroup]);

    // Expanded: the group name as a button that shows or hides the group. Collapsed to
    // icons: a short rule, and every icon stays visible, since there is no name to click.
    // Same height either way, so toggling the drawer does not shift the icons.
    const renderGroupHeader = (title) => (
        <ListSubheader
            component="li"
            disableSticky
            sx={{
                height: 28,
                lineHeight: '28px',
                mt: 0.5,
                px: 0,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'transparent'
            }}
        >
            {contentExpanded ? (
                <ButtonBase
                    onClick={() => setNavGroupOpen(title, !isNavGroupOpen(title))}
                    aria-expanded={isNavGroupOpen(title)}
                    sx={{
                        width: '100%',
                        height: '100%',
                        px: 1.5,
                        borderRadius: '8px',
                        justifyContent: 'space-between',
                        color: '#6b7a99',
                        fontSize: 11,
                        fontWeight: 700,
                        letterSpacing: '0.08em',
                        whiteSpace: 'nowrap',
                        '&:hover': { backgroundColor: '#e5f4fb', color: '#3FA7D6' }
                    }}
                >
                    {title}
                    <ExpandMore sx={{
                        fontSize: 18,
                        transition: 'transform 150ms ease',
                        transform: isNavGroupOpen(title) ? 'rotate(180deg)' : 'none'
                    }} />
                </ButtonBase>
            ) : (
                <Box component="span" aria-label={title} sx={{ width: 24, borderTop: '1px solid #c9dfea' }} />
            )}
        </ListSubheader>
    );

    // A click on empty sidebar space toggles the drawer. Clicks on menu items, group
    // headers, links and buttons keep doing their own thing.
    const toggleFromEmptySpace = (event) => {
        if (event.target.closest('a, button, [role="button"], .MuiListItem-root')) return;
        setOpen(current => !current);
    };

    return(
        <div className='sidebar-mainDiv' style={{ display: 'flex', height: '100%',}}>
            <BasicCompanySettingsModal user={props.user}></BasicCompanySettingsModal>
            <SubscriptionModal user={props.user}></SubscriptionModal>
            <MessageBanner user={props.user} />
            <Drawer 
                variant="permanent"
                open={open}
                onTransitionEnd={onTransitionEnd}
                style={{ zIndex: 1 }}
            >
                {/* <div style={{ height: "250px", backgroundColor: "rgb(235, 248, 255)", borderRight: '1px solid #3FA7D6' }} /> */}
                <List sx={{ ...navigationListSx, cursor: 'pointer' }} onClick={toggleFromEmptySpace}>
                    {showButtonHome()}
                    {showButtonNew()}
                    {navGroups.map(group => (
                        <React.Fragment key={group.title}>
                            {renderGroupHeader(group.title)}
                            {(!contentExpanded || isNavGroupOpen(group.title)) &&
                                group.items.map(([key, item]) => <React.Fragment key={key}>{item}</React.Fragment>)}
                        </React.Fragment>
                    ))}
                </List>
                <div 
                    style={{ 
                        display: "flex", 
                        flexDirection: "column", 
                        width: '100%', 
                        textAlign: 'center', 
                        minHeight: '64px',
                        flexShrink: 0,
                        backgroundColor: '#eaf5fa',
                        borderTop: '1px solid #d8e8f0',
                        justifyContent: 'flex-end',
                        cursor: 'pointer'
                    }}
                    onClick={toggleFromEmptySpace}>
                    <div style={{ display: 'flex', justifyContent: contentExpanded ? 'flex-end' : 'center', alignItems: 'center', height: '42px', padding: contentExpanded ? '0 12px' : 0 }}>
                        <Tooltip title={open ? 'Collapse navigation' : 'Expand navigation'} placement="right">
                            <IconButton
                                aria-label={open ? 'Collapse navigation' : 'Expand navigation'}
                                onClick={() => setOpen(current => !current)}
                                size="small"
                                sx={{
                                    width: 30,
                                    height: 30,
                                    color: '#3FA7D6',
                                    backgroundColor: '#d6eef9',
                                    border: '1px solid #b9deef',
                                    '&:hover': {
                                        color: '#ffffff',
                                        backgroundColor: '#3FA7D6'
                                    }
                                }}
                            >
                                {open ? <KeyboardDoubleArrowLeft fontSize="small" /> : <KeyboardDoubleArrowRight fontSize="small" />}
                            </IconButton>
                        </Tooltip>
                    </div>
                    <div>
                        <a style={{ width: '100%', color: '#6b7a99', whiteSpace: 'nowrap', fontSize: '11px', marginBottom: '7px', display: 'inline-block' }} href="https://fieldworker.ai/termsandconditions/" target="_blank" rel="noreferrer">{contentExpanded ? 'Terms of Service' : 'Terms'}</a>
                    </div>
                </div>
            </Drawer>
            <div style={{ marginLeft: '10px', marginRight: '10px', marginTop: '15px', minWidth: 0, flex: 1, overflow: 'hidden', height: '100%' }}>
                <Switch>
                    {/* Support Coordination Homepages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 101).length > 0 && !['Manager', 'Support Coordinator'].includes(props.user.type) &&
                            <Route exact path="/home" >
                                <SupportCoordinationEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 101).length > 0 && !['Manager', 'Support Coordinator'].includes(props.user.type) &&
                            <Route exact path="/" >
                                <SupportCoordinationEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}

                    {/* Service Provider Homepages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 102).length > 0 && 
                            <Route exact path="/home" >
                                <ServiceProviderEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 102).length > 0 && 
                            <Route exact path="/" >
                                <ServiceProviderEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}

                    {/* Home Healthcare Homepages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 103).length > 0 && 
                            <Route exact path="/home" >
                                <HomeHealthcareEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 103).length > 0 && 
                            <Route exact path="/" >
                                <HomeHealthcareEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}

                    {/* Case Management Homepages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 104).length > 0 && 
                            <Route exact path="/home" >
                                <CaseManagementEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 104).length > 0 && 
                            <Route exact path="/" >
                                <CaseManagementEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}

                    {/* Day Care Or Community Center Homepages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 105).length > 0 && 
                            <Route exact path="/home" >
                                <DayCareEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 105).length > 0 && 
                            <Route exact path="/" >
                                <DayCareEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}

                    {/* Group Home Homepages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 106).length > 0 && 
                            <Route exact path="/home" >
                                <HomeHealthcareEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 106).length > 0 && 
                            <Route exact path="/" >
                                <HomeHealthcareEmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id}/>
                            </Route>
                        : <></>}
                    
                    {/* Manager Homes Pages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 101).length > 0 && ['Manager'].includes(props.user.type) &&
                            <Route exact path="/home" >
                                <SupportCoordinatorSupervisorHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} mapRender={toModule}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 101).length > 0 && ['Manager'].includes(props.user.type) &&
                            <Route exact path="/" >
                                <SupportCoordinatorSupervisorHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} mapRender={toModule}/>
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 104).length > 0 && ['Manager'].includes(props.user.type) &&
                            <Route exact path="/home" >
                                <EmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                            </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 104).length > 0 && ['Manager'].includes(props.user.type) &&
                            <Route exact path="/" >
                                <EmployeeHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                            </Route>
                        : <></>}

                    {/* Misc Homes Pages */}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 101).length > 0 && ['Support Coordinator'].includes(props.user.type) &&
                        <Route exact path="/home">
                            <SupportCoordinatorHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} mapRender={toModule}/>
                        </Route>
                        : <></>}
                        {companySettings.length > 1 ? companySettings.filter(setting => setting.feature_id == 101).length > 0 && ['Support Coordinator'].includes(props.user.type) &&
                        <Route exact path="/" >
                            <SupportCoordinatorHome {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} mapRender={toModule}/>
                        </Route>
                        : <></>}
                    
                    <Route exact path="/settings">
                        <Settings {...props} updateSubs={props.updateSubs} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} />
                    </Route>
                    <Route exact path="/new">
                        <SideBar {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} mapRender={toModule} />
                    </Route>
                    <Route exact path="/projects">
                        <Projects key={String(props.selectedProgramId ?? 'all-programs')} {...props} changeScreen={changeScreen} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} companySettings={companySettings} selectedProgramId={props.selectedProgramId} />
                    </Route>
                    <Route exact path="/customers">
                        <Customers key={String(props.selectedProgramId ?? 'all-programs')} {...props} changeScreen={changeScreen} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} selectedProgramId={props.selectedProgramId} />
                    </Route>
                    <Route exact path="/households">
                        <Households {...props} changeScreen={changeScreen} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} />
                    </Route>
                    <Route exact path="/residences">
                        <Residences {...props} changeScreen={changeScreen} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} />
                    </Route>
                    <Route exact path="/contacts">
                        <Contacts {...props} changeScreen={changeScreen} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} />
                    </Route>
                    <Route exact path="/locate">
                        <EmpLocate {...props} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} />
                    </Route>
                    <Route exact path="/reports">
                        <Reports_V2 {...props} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} page={'Reports'} />
                    </Route>
                    <Route exact path="/notifications">
                        <Notifications {...props} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} user={props.user} page={'Notifications'} />
                    </Route>
                    <Route exact path="/team">
                        <EmployeePage {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                    </Route>
                    <Route exact path="/employees">
                        <EmployeePage {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                    </Route>
                    <Route exact path="/team-workload">
                        <TeamWorkload {...props} user={props.user} />
                    </Route>
                    <Route exact path="/debug">
                        <DebugContainer />
                    </Route>
                    {!!props.user.role === 'Admin' &&
                        <Route exact path="/invoice">
                        <Invoice {...props} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} />
                        </Route>
                    }
                    {!!props.user.subs.find((d)=> d.feature_id === 11) &&
                        <Route exact path="/evv">
                            <EvvV1 {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                        </Route>
                    }
                    {!!props.user.subs.find((d)=> d.feature_id === 11) &&
                        <Route exact path="/evvAZ">
                            <EVV_AZ {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                        </Route>
                    }
                    {!!props.user.subs.find((d)=> d.feature_id === 12) &&
                        <Route exact path="/timesheets">
                            <TimeSummaryAlt2 {...props} company_id={props.comp_id} checkTokenExpiry={props.checkTokenExpiry} user={props.user} />
                        </Route>
                    }
                    {!!props.user.subs.find((d)=> d.feature_id === 15) &&
                        <Route exact path="/formbuilder">
                            <FormBuilder {...props} checkTokenExpiry={props.checkTokenExpiry} comp_id={props.comp_id} />
                        </Route>
                    }
                    {!!props.user.subs.find((d)=> d.feature_id === 18) &&
                        <Route exact path="/billing">
                            <Billing {...props} payerList={payerList} changeScreen={changeScreen} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                        </Route>
                    }
                    <Route exact path="/documents">
                        <Documents {...props} comp_id={props.comp_id} checkTokenExpiry={props.checkTokenExpiry} user={props.user} />
                    </Route>
                    <Route exact path="/forms">
                        <Forms {...props} changeScreen={changeScreen} comp_id={props.comp_id} checkTokenExpiry={props.checkTokenExpiry} user={props.user} />
                    </Route>
                    {/* Referral route placed before scheduler for precedence */}
                    <Route exact path="/referral">
                        <Referral {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                    </Route>
                    <Route exact path="/scheduler">
                        <Scheduler {...props} changeScreen={changeScreen} comp_id={props.comp_id} checkTokenExpiry={props.checkTokenExpiry} user={props.user} />
                    </Route>
                    <Route exact path="/workflows">
                        <Workflows {...props} changeScreen={changeScreen} comp_id={props.comp_id} user={props.user} open={open} />
                    </Route>
                    <Route exact path="/ai-companion">
                        <AiCompanion {...props} checkTokenExpiry={props.checkTokenExpiry} user={props.user} comp_id={props.comp_id} />
                    </Route>
                </Switch>
            </div>
        </div>
    );
}
